import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const isDarkModeAtom = atom(false);
export const headerMenuKeyAtom = atom('dashboard');
export const menuDrawerOpenAtom = atom(false);
export const messageAtom = atom([]);
export const userAtom = atomWithStorage('user', null);
export const userRecordAtom = atomWithStorage('userRecord', null);

export const showToastAtom = atom(false);
export const toastAtom = atom({ severity: 'info', duration: 0, message: ''});
export const classListAtom = atom([]);

export const currentParentMessageAtom = atom([]);
export const currentTeacherMessageAtom = atom([]);
export const currentClassMessageAtom = atom([]);
export const currentParentsinClassMessageAtom = atom([]);
export const allParentConversationsAtom = atom([]);
export const allTeachersConversationsAtom = atom([]);
export const unreadMessagesAtom = atom([]);
export const unreadTeacherMessagesAtom = atom([]);
export const unreadParentMessagesAtom = atom([]);
export const pauseMessageListenerAtom = atom(false);
export const isMessageAllModalOpenAtom = atom(false);
export const messageTabAtom = atom('All');
export const messageNotificationAtom = atom({ title: null, options: null, data: null });
export const currentOpenConversationMessagesAtom = atom()